import * as React from 'react'
import { useIntl } from '@/intl'
import MultiSelectPricesFilter, {
  mapLocalSelectionToGA4Result,
} from '@/scopes/prices/components/Filters/MultiSelectPricesFilter'
import { durationFilterOptionsSelector } from '@/scopes/prices/components/selectors'
import { createPricesFilterClickEvent } from '@/scopes/prices/domain/analytics'
import {
  FiltersInPricesValues,
  Option,
} from '@/scopes/prices/domain/filters/types'
import { PricesActionsContext } from '@/scopes/prices/domain/PricesActionsContext'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'

export function DurationDropdownFilter() {
  const intl = useIntl()
  const { selectFilter } = React.use(PricesActionsContext)
  const { options, selectedValues } = usePricesSelector(durationFilterOptionsSelector)
  const setSelection = (selection: FiltersInPricesValues) => selectFilter({ type: 'Duration', selection })
  return (
    <MultiSelectPricesFilter
      options={options}
      selectedValues={selectedValues}
      setSelection={setSelection}
      label={intl.formatMessage({ id: 'prices_filters_durations_label' })}
      placeholder={intl.formatMessage({ id: 'prices_filters_durations_placeholder' })}
      confirmButton={intl.formatMessage({ id: 'quicksearch_save_button_text' })}
      analyticsEventBuilder={(selection: string | string[] | undefined, options: Option[]) => {
        return createPricesFilterClickEvent({
          element: 'dropdown',
          type: 'duration',
          result: mapLocalSelectionToGA4Result(selection, options),
        })
      }}
    />
  )
}
